import React, { useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

/** PrimeReact */
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

/** Mol UI */
import MolForm, { Field } from "@moltech/molui/molform";
import Toast from "@moltech/molui/toast";

import { decryptUrlData } from "../../utils/encryption/CryptoService";
import { getAuthProps } from "../../utils/authentication/authLibrary";

/** API */
import { useForgotPasswordMutation } from "../../app/services/authApi";

const initialValue = {
    email: "",
    password: "",
    confirmPassword: "",
};

const ForgotPassword = () => {
    const loginFormRef = useRef(null);
    const navigate = useNavigate();
    const params = useParams();

    /** Get Email From URL */
    const email = params?.email ? decryptUrlData(params.email) : "";

    /** Get UserId */
    const authData = getAuthProps();
    let userId = authData?.user?.userId || null;

    if (!userId && params?.id) {
        userId = decryptUrlData(params.id);
    }

    const [formValues] = useState({
        ...initialValue,
        email: email,
    });

    const [saveUserDetails, { isLoading: isSavingData }] =
        useForgotPasswordMutation();

    /** Submit Form */
    const handleFormSubmit = () => {
        const formData = loginFormRef.current?.getData();
        if (!formData) return;
        const req = {
            userId: userId || 0,
            EmailAddress: formData.email,
            isResetPasswordRequired: false,
        };

        saveUserDetails(req).then((res) => {
            if (res?.error) {
                Toast.error(
                    res?.error?.data?.message ||
                    res?.error?.message ||
                    "Something went wrong!"
                );
            } else {
                Toast.success(res.data.message || "Email sent successfully!");
                navigate("/login");
            }
        });
    };

    /** Reset Button */
    const onSave = () => {
        loginFormRef.current?.submit();
    };

    /** Back To Login */
    const handleReturnClick = () => {
        navigate("/login");
    };

    return (
        <div className="reset-password-page">
            <div className="login-page-card">
                <div className="login-form">
                    <div className="login-card">
                        <img
                            className="big-logo"
                            src="/images/logo.png"
                            alt="logo"
                        />

                        <h2>Welcome to MoltechR</h2>

                        <p className="sub-text">
                            Enter your new password to reset your account.
                        </p>

                        <div className="saporate-line"></div>

                        <MolForm
                            ref={loginFormRef}
                            onSubmit={handleFormSubmit}
                            initialValues={formValues}
                        >
                            {/* Email */}
                            <div className="form-field">
                                <Field
                                    component={InputText}
                                    name="email"
                                    label="Email Address"
                                />
                            </div>
                        </MolForm>

                        {/* Buttons */}
                        <Button
                            label="Send Email"
                            loading={isSavingData}
                            disabled={isSavingData}
                            className="btn primary-btn login-btn"
                            onClick={onSave}
                        />

                        <Button
                            label="Return to Login"
                            className="btn login-btn-outline"
                            onClick={handleReturnClick}
                        />

                        <div className="bottom-text">
                            <span>
                                A lightweight HR management system that helps
                                track employees, attendance, and leave requests
                                in one place.
                            </span>
                        </div>
                    </div>
                </div>

                <div className="login-image">
                    <img src="/images/login-bg.png" alt="HRMS" />
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;